module.exports = __webpack_public_path__ + "img/Pattern06.fc7379f0.png";